// extracted by mini-css-extract-plugin
export default {"Details":"SbH2mD","details":"SbH2mD","open":"Y9xECX","borderless":"L5kO9M","summary":"pLOgkF","arrowRight":"iJFbAU","white":"v8BVtD","content":"kv3dQz"};